import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useState } from "react";
import {
  formatFileSize,
  validatePhoneNumber,
} from "../../../utility-functions";
import GModal from "../../design/components/GModal";
import CloseIcon from "@mui/icons-material/Close";
import campaignSampleFile from "../../../assets/campaign_sample.csv";
import baseFileIcon from "../../../assets/base file icon.svg";
import Button from "../../design/Button";
import { JService } from "../../api-service/ApiService";
import { enqueueSnackbar } from "notistack";
import {
  CCDropdown,
  CustomInput,
  CustomSelect,
} from "../../design/components/customComponents";
import { useSelector } from "react-redux";
import HubspotContactsTable from "../../contact-lists/HubspotContactsTable";
import {
  chevronLeft,
  chevronRight,
  link,
} from "../../../utility-functions/assetLoader";
import { useNavigate } from "react-router-dom";
import HubspotIcon from "../../../assets/HubspotIcon.svg";
import "../../contact-lists/contactListsStyles.css";

const importOptions = [
  { value: "Upload list", displayValue: "Upload list" },
  { value: "Import from CRM", displayValue: "Import from CRM" },
];

const MAX_FILE_SIZE = 10 * 1024 * 1024;

function AddContactModal({
  visible,
  hideModal,
  listId,
  triggerReload,
  listName,
}) {
  //States
  const [type, setType] = useState("single");
  const [newListFile, setNewListFile] = useState([]);
  const [newContactName, setNewContactName] = useState("");
  const [newContactNumber, setnewContactNumber] = useState({
    value: "",
    error: "",
  });
  const [countryCode, setCountryCode] = useState({ value: "+91", error: "" });
  const [importType, setImportType] = useState("Upload list");
  const [showCRMContacts, setShowCRMContacts] = useState(false);
  const [selectedHubspotContacts, setSelectedHubspotContacts] = useState([]);

  const hubspotAccess = useSelector(
    (state) => state?.account?.value?.data?.profile?.hubspot_access
  );
  const navigate = useNavigate();

  //Handlers
  const closeModal = () => {
    setNewListFile([]);
    setNewContactName("");
    setnewContactNumber({ value: "", error: null });
    setCountryCode({ value: "+91", error: null });
    setShowCRMContacts(false);
    setImportType("Upload list");
    hideModal();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let url, payload;
    if (type === "import") {
      url = `/api/v1/core/upload-contacts/${listId}/`;
      payload = new FormData();
      payload.append("file", newListFile[0]);
    } else if (type === "single") {
      url = `/api/v1/core/create-contact/${listId}/`;
      payload = {
        name: newContactName,
        country_code: countryCode.value,
        number: newContactNumber.value,
      };
    }

    JService.post(url, payload)
      .then((res) => {
        if (!res?.success)
          throw new Error(res?.message || "Error while creating contact list");
        enqueueSnackbar(res?.message, { variant: "success" });
        triggerReload();
        closeModal();
      })
      .catch((err) => enqueueSnackbar(err?.message, { variant: "error" }));
  };

  const importContactsHandler = () => {
    if (selectedHubspotContacts?.length === 0) return;

    JService.post(
      `/api/v2/integrations/create-contact-list-from-hubspot/?contact_list_id=${listId}&title=${listName}`,
      {
        total_result: selectedHubspotContacts,
      }
    )
      .then((response) => {
        if (!response?.success)
          throw new Error(
            response?.message || "Error while importing hubspot contacts"
          );
        enqueueSnackbar(response?.message || "Contacts will be added shortly", {
          variant: "success",
        });
        triggerReload();
      })
      .catch((err) =>
        enqueueSnackbar(
          err?.message || "Error while importing hubspot contacts",
          {
            variant: "error",
          }
        )
      )
      .finally(() => {
        closeModal();
      });
  };

  return (
    <GModal
      modalStyle={{ width: "500px" }}
      closeModal={closeModal}
      bodyWrapperStyle={{ overflowY: "visible" }}
      heading={"Add Contacts"}
      visible={visible}
      bottomButtons={[
        <Button
          className="ui--button ui--cancel"
          variant="filled"
          buttonText="Cancel"
          icon={{}}
          disabled={false}
          isLoading={false}
          hierarchy="white"
          onClick={closeModal}
        />,
        !showCRMContacts ? (
          <Button
            className="ui--button ui--add"
            variant="filled"
            buttonText="Add"
            icon={{}}
            disabled={
              type === "import"
                ? newListFile.length === 0
                : newContactName.length === 0 || newContactNumber.error
            }
            isLoading={false}
            hierarchy="green"
            onClick={(e) => handleSubmit(e)}
          />
        ) : (
          <Button
            variant="filled"
            buttonText={`Import ${selectedHubspotContacts?.length} contacts`}
            disabled={selectedHubspotContacts?.length === 0}
            isLoading={false}
            hierarchy="green"
            onClick={importContactsHandler}
          />
        ),
      ]}
      body={
        showCRMContacts ? (
          <>
            <button
              className="crm-contacts-back-button"
              onClick={() => setShowCRMContacts(false)}
            >
              {chevronLeft("20", "20", "#3F3F46")}
              <span>Back</span>
            </button>
            <HubspotContactsTable
              setSelectedHubspotContacts={setSelectedHubspotContacts}
            />
          </>
        ) : (
          <div>
            <FormControl sx={{ marginBottom: "40px" }}>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="single"
                name="radio-buttons-group"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <div style={{ display: "flex" }}>
                  <FormControlLabel
                    value="single"
                    control={<Radio sx={localStyles.radioStyle} />}
                    label="Add individually"
                  />
                  <FormControlLabel
                    value="import"
                    control={<Radio sx={localStyles.radioStyle} />}
                    label="Import contacts"
                  />
                </div>
              </RadioGroup>
            </FormControl>

            <form className="new-contact-list-form add-contact-form">
              {type === "single" && (
                <>
                  <label
                    className="t7 medium-font"
                    style={{ marginBottom: "32px" }}
                  >
                    Name
                    <input
                      placeholder="Enter Contact Name"
                      className="t7 ui--input ui--name"
                      type="text"
                      onChange={(e) => setNewContactName(e.target.value)}
                      value={newContactName}
                    />
                  </label>
                  <CustomInput
                    dropdown={
                      <CCDropdown
                        selectedCountryCode={countryCode?.value}
                        handleCountrySelect={(val) => {
                          setCountryCode({ value: val, error: null });
                          setnewContactNumber((prev) => ({
                            ...prev,
                            error: !validatePhoneNumber(val, prev.value),
                          }));
                        }}
                      />
                    }
                    value={newContactNumber}
                    label="Phone number"
                    handleFocus={() => null}
                    handleChange={(e) => {
                      setnewContactNumber({
                        value: e.target.value,
                        error: !/^\d+$/.test(e.target.value) || !validatePhoneNumber(
                          countryCode?.value,
                          e.target.value
                        ),
                      });
                    }}
                    name="phone_number"
                    type="tel"
                  />
                </>
              )}

              {type === "import" && (
                <>
                  <CustomSelect
                    label=""
                    name="import-type"
                    value={importType}
                    handleChange={(e) => setImportType(e.target.value)}
                    options={importOptions}
                    menuWidth="400px"
                  />
                  {importType === "Upload list" ? (
                    <>
                      <label
                        htmlFor="upload-list-file"
                        className="upload-file-label"
                      >
                        {newListFile.length === 0 && (
                          <>
                            <div className="no-file">
                              <div>
                                <a className="t6 ic-green-500">
                                  Click to upload
                                </a>
                                <span className="t6 medium-font">
                                  &nbsp;or drag and drop
                                </span>
                                <p className="t8 regular-font nc-gray-600">
                                  File format: csv, xls or xlsx (max size: 10MB)
                                </p>
                              </div>
                            </div>
                            <input
                              // key={fileKey || ""}
                              id="upload-list-file"
                              placeholder="or drag and drop files here"
                              className="regular-font t7"
                              name="file"
                              type="file"
                              disabled={newListFile[0]?.name}
                              accept={".csv,.xls,.xlsx"}
                              onChange={(e) => {
                                const _file = e.target.files[0];
                                if (_file?.size > MAX_FILE_SIZE) {
                                  enqueueSnackbar("File size cannot exceed 10 MB", { variant: "error" });
                                  setNewListFile([]);
                                  return;
                                }
                                if (
                                  _file?.type === "text/csv" ||
                                  _file?.type ===
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                                  _file?.type === "application/vnd.ms-excel"
                                ) {
                                  setNewListFile([e.target.files[0]]);
                                  // setFormListener((prevState) => prevState + 1);
                                } else setNewListFile([]);
                              }}
                            />
                          </>
                        )}
                        {newListFile[0]?.name && (
                          <div className="has-file">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <img src={baseFileIcon} alt="" />
                              <div
                                className="t6 regular-font"
                                style={{
                                  marginLeft: "20px",
                                }}
                              >
                                {/* <p className="nc-gray-900">{newListFile[0]?.name}</p> */}
                                <p className="nc-gray-900">
                                  {newListFile[0].name.substring(0, 27)}
                                  {newListFile[0].name.length > 27 ? "…" : ""}
                                </p>
                                <p className="nc-gray-600">
                                  {formatFileSize(newListFile[0]?.size)}
                                </p>
                              </div>
                            </div>
                            <CloseIcon
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                // e.stopPropagation();
                                setNewListFile([]);
                                // setFormListener((prevState) => prevState + 1);
                              }}
                            />
                          </div>
                        )}
                      </label>
                      <a
                        download="campaign_sample.csv"
                        href={campaignSampleFile}
                        className="ic-green-500 regular-font t7"
                        style={{
                          cursor: "pointer",
                          lineHeight: "20px",
                          textDecoration: "underline",
                        }}
                      >
                        Download sample file
                      </a>
                    </>
                  ) : hubspotAccess ? (
                    <div
                      onClick={() => setShowCRMContacts(true)}
                      className="crm-container"
                    >
                      <div>
                        <div>
                          <img src={HubspotIcon} alt="hubspot-icon" />
                        </div>
                        <h6>Import from HubSpot</h6>
                      </div>
                      {chevronRight("#3F3F46")}
                    </div>
                  ) : (
                    <div
                      onClick={() =>
                        navigate("/settings", {
                          state: { tab: "Integrations" },
                        })
                      }
                      className="connect-crm"
                    >
                      {link("20", "20", "#2AA251")}
                      <span>Connect CRM</span>
                    </div>
                  )}
                </>
              )}
            </form>
          </div>
        )
      }
    />
  );
}

export default AddContactModal;

const localStyles = {
  radioStyle: {
    "&, &.Mui-checked": {
      color: "#2EB358",
    },
  },
};
